import React, { createContext, useEffect, useState } from 'react';
import { useGetServiceDiscoveryGetUrls } from '../api/service-discovery/service-discovery';
import { getCalculationReviewUrl } from '../utils/EnvironmentUtils';

export interface IServiceDiscoveryConfig {
    appInsightsConnectionString: string | undefined;
    homeUrl: string | undefined;
    cartManagerUrl: string | undefined;
    calculationReviewUrl?: string | undefined;
    helpUrl?: string | undefined;
    idpUrl?: string | undefined;
    entityGeneralPropertiesUrl?: string | undefined;
    posthogProjectToken?: string | undefined;
    posthogHost?: string | undefined;
    entityObligationPropertiesUrl?: string | undefined;
}

interface IAppSettings {
    appInsightsConnectionString: string;
    homeUrl: string;
    helpUrl: string;
    idpUrl: string;
    entityGeneralPropertiesUrl: string;
    posthogProjectToken: string;
    posthogHost: string;
    entityObligationPropertiesUrl: string;
}

export const ServiceDiscoveryContext = createContext<IServiceDiscoveryConfig | null>(null);

export function ServiceDiscoveryContextProvider(props: { value?: IServiceDiscoveryConfig; children?: React.ReactNode }) {
    const [appSettings, setAppSettings] = useState<IAppSettings>({
        appInsightsConnectionString: '',
        homeUrl: '',
        helpUrl: '',
        idpUrl: '',
        entityGeneralPropertiesUrl: '',
        posthogProjectToken: '',
        posthogHost: '',
        entityObligationPropertiesUrl: '',
    });

    const { data: serviceDiscoveryUrls, isSuccess } = useGetServiceDiscoveryGetUrls();

    const calculationReviewUrl = getCalculationReviewUrl(window.location.host);

    useEffect(() => {
        if (isSuccess) {
            setAppSettings({
                appInsightsConnectionString: serviceDiscoveryUrls.appInsightsConnectionString ?? '',
                homeUrl: serviceDiscoveryUrls.homeUrl || '',
                helpUrl: `${serviceDiscoveryUrls?.helpUrl}`,
                idpUrl: serviceDiscoveryUrls?.idpUrl || '',
                entityGeneralPropertiesUrl: serviceDiscoveryUrls?.entityGeneralPropertiesUrl || '',
                posthogProjectToken: serviceDiscoveryUrls?.posthogProjectToken ?? '',
                posthogHost: serviceDiscoveryUrls?.posthogHost ?? '',
                entityObligationPropertiesUrl: serviceDiscoveryUrls?.entityObligationPropertiesUrl ?? '',
            });
        }
    }, [serviceDiscoveryUrls, isSuccess]);

    return (
        <ServiceDiscoveryContext.Provider
            value={
                props.value ?? {
                    ...appSettings,
                    cartManagerUrl: serviceDiscoveryUrls?.cartManagerUrl || '',
                    calculationReviewUrl,
                }
            }
        >
            {props.children}
        </ServiceDiscoveryContext.Provider>
    );
}

export default ServiceDiscoveryContextProvider;
